import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiResponse } from '@app/core/responses/fdx-api.response';
import { ExportInterface } from '@app/exports/models/interfaces/export.interface';
import { ImportInterface } from '@app/imports/models/interfaces/import.interface';
import { CronInterface } from '@app/modules/schedule/models/interfaces/cron.interface';
import { UpdateScheduleRequest } from '@app/modules/schedule/services/requests/schedule-update.request';
import { GetSchedulesResponse } from '@app/modules/schedule/services/responses/get-schedules.response';
import { UpdateScheduleResponse } from '@app/modules/schedule/services/responses/schedule-update.response';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class ScheduleDataService {

    constructor(
        private readonly http: HttpClient
    ) { }

    updateImportSchedule(databaseId: string, importData: ImportInterface, cronData: CronInterface): Observable<UpdateScheduleResponse> {
        return this.http.put<UpdateScheduleResponse>(
            `/api.php/dbs/${databaseId}/imports/${importData.id}/schedule`,
            this.getUpdateParams(importData, cronData)
        );
    }

    updateExportSchedule(databaseId: string, exportData: ExportInterface, cronData: CronInterface): Observable<UpdateScheduleResponse> {
        return this.http.put<UpdateScheduleResponse>(
            `/api.php/dbs/${databaseId}/exports/${exportData.id}/schedule`,
            this.getUpdateParams(exportData, cronData)
        );
    }

    getOldestImportSchedule(databaseId: string): Observable<ApiResponse<GetSchedulesResponse>> {
        return this.http.get<ApiResponse<GetSchedulesResponse>>(`/api.php/dbs/${databaseId}/schedules?oldest_only=true&type=import`);
    }

    getOldestExportSchedule(databaseId: string): Observable<ApiResponse<GetSchedulesResponse>> {
        return this.http.get<ApiResponse<GetSchedulesResponse>>(`/api.php/dbs/${databaseId}/schedules?oldest_only=true&type=export`);
    }

    private getUpdateParams(data: ExportInterface | ImportInterface, cronData: CronInterface): UpdateScheduleRequest {
        const params = {
            day: cronData.day && this.processArray(cronData.day),
            hour: cronData.hour && this.processArray(cronData.hour),
            minute: cronData.minute && this.processArray(cronData.minute),
            timezone: data.cron_timezone,
            paused: data.paused
        };
        return params;
    }

    private processArray(val: string[]): string {
        return val.length === 0 ? '-1' : val.join(',');
    }
}
